import { Component, ElementRef, inject, LOCALE_ID } from '@angular/core'
import { NgOptimizedImage } from '@angular/common'
import { IconComponent } from 'src/app/elements/icon/icon.component'
import { CookieKey } from 'src/server/server.data'
import { CookieInterface } from 'src/tools/cookie.tools'
import { i18nPath } from 'src/tools/i18n.tools'

@Component({
  selector: 'app-i18n-suggest',
  imports: [
    NgOptimizedImage,
    IconComponent,
  ],
  templateUrl: './i18n-suggest.component.html',
  styleUrl: './i18n-suggest.component.sass',
})
export class I18nSuggestComponent {
  protected elementRef = inject(ElementRef)
  protected appLocale = inject(LOCALE_ID)
  protected localeId = navigator.language.split('-')[0]
  protected content = {
    de: { label: 'Diese Seite ist ebenfalls in Deutsch verfügbar', action: 'Zur Seite in Deutsch' },
    en: { label: 'This page is also available in English', action: 'To the English page' },
    zh: { label: '本页面还有中文版', action: '到中文页面' },
    es: { label: 'Esta página también está disponible en inglés', action: 'Ir a la página en español' },
    fr: { label: 'Cette page est également disponible en allemand ', action: 'Vers le site français' },
  }[this.localeId] as { label: string, action: string }
  protected path = i18nPath()

  hide () {
    // assume the user is fine with the current locale
    CookieInterface.set(CookieKey.I18nSelection, this.appLocale)
    this.elementRef.nativeElement.remove()
  }

  select () {
    CookieInterface.set(CookieKey.I18nSelection, this.localeId)
  }
}
